import type { JSX } from 'react';
import { Icon } from '@ndrc/ui';
import type { ClassDocument } from '../lib/queries';
import { t } from '../messages';
import { formatFileSize } from './fileSize';
import './documents.css';

/**
 * **La pièce jointe d'une consigne**, telle que l'élève la voit sous les instructions — et telle
 * que l'enseignant la retrouve dans sa liste d'activités.
 *
 * Une ligne, pas une liste : une consigne porte au plus un document (`core.activities.resource_id`).
 * Écrit une fois pour les deux écrans, pour la même raison que `DocumentList` : l'enseignant doit
 * voir exactement ce que sa classe voit.
 *
 * Le lien est un vrai `<a href>` vers l'adresse signée — voir `DocumentList` pour pourquoi ce n'est
 * pas un bouton, et pourquoi il ne force pas le téléchargement.
 */
export function AttachedDocument({ document }: { document: ClassDocument }): JSX.Element {
  return (
    <div className="documents-attached">
      <span className="documents-glyph" aria-hidden="true">
        <Icon name="file" size={16} strokeWidth={1.7} />
      </span>
      <span className="documents-meta">
        <span className="documents-name">{document.name}</span>
        <span className="documents-sub">{formatFileSize(document.sizeBytes)}</span>
      </span>
      {document.url === null ? (
        <span className="documents-unavailable">{t('documents.noLink')}</span>
      ) : (
        <a className="ndrc-button" href={document.url} target="_blank" rel="noreferrer">
          {t('documents.open')}
        </a>
      )}
    </div>
  );
}
